import React, {
    useEffect,
} from 'react'
import {
    useTranslation,
} from 'react-i18next'
import ReactGA from 'react-ga4'

import RenderRoutes from './shared-components/RenderRoutes/RenderRoutes'

const TRACKING_ID = 'G-VQTBXN5BFF'

function App() {
    const {
        i18n,
    } = useTranslation()

    useEffect(() => {
        if (i18n.isInitialized) {
            const savedLanguage = localStorage.getItem('LANGUAGE')
            const appLanguage = savedLanguage ?? navigator.language ?? 'en'

            i18n.changeLanguage(appLanguage.toLowerCase())
        }
    }, [i18n])

    useEffect(() => {
        ReactGA.initialize(TRACKING_ID)
        // Send pageview with a custom path
        ReactGA.send({
            hitType: 'pageview', title: 'SkyGate Sane Gateway QR Page',
        })
    }, [])

    return <RenderRoutes />
}

export default App
